export const games = {
  titleBreakingLeague: "ESTÁN ROMPIENDO LA LIGA",
  titleBreakingLeagueMobile: "💥 ESTÁN ROMPIENDO LA LIGA",
  gamesSubTitle: "No quieren dejar pa' nadie.",
  recentTitle: "LOS MÁS RECIENTES",
  recentTitleMobile: "📢 LOS MÁS RECIENTES",
  recentTitleProvider: "LOS MÁS RECIENTES DE {{provider}}",
  recentSubTitle: "Prueba suerte con nuestras novedades",
  recentSubTitleProvider: "Las novedades de {{provider}}",
  newLabel: "NUEVO",
  top10GamesTitle: "LOS",
  top10GamesTitle2: "MÁS JUGADOS",
  top10GamesSubTitleDesktop: "Los favoritos de la semana",
  top10GamesSubTitleMobile: "LOS <highlight>10</highlight> MÁS JUGADOS",
  top10GamesSubTitleDesktopProvider: "Los favoritos de la semana en {{provider}}",
  top10GamesSubTitleMobileProvider: "LOS <highlight>10</highlight> MÁS JUGADOS DE {{provider}}",
  randomTitle: "¿No te decides?",
  randomTitleMobile: "🍀 Que la suerte decida!",
  randomDescription: "Dale play y deja que la suerte elija.",
  randomDescriptionMobile: "Dale play y deja que la suerte elija.",
  selectCategory: "Elige una categoría",
  randomPlayButton: "¡A jugar!",
  randomQuestion: "¿Cuál será el próximo juego en darte suerte? 🍀",
  randomButton: "Ir al juego 🚀",
  randomChipAll: "Todo",
  randomTryAnother: "Probar otro",
  randomNoGames: "No hay juegos en esta categoría",
  randomPromoTitle: "Descubre tu próximo juego favorito",
  randomPromoText: "Miles de juegos te esperan. Deja que la suerte elija por ti y encuentra nuevas experiencias.",
  randomPromoHint: "Prueba el selector aleatorio →",
  topPayingGamesTitle: "LOS QUE MÁS PAGAN",
  topPayingGamesSubTitle: "Andan soltando money",
  recentlyPlayedTitle: "CONTINÚA DONDE LO DEJASTE",
  recentlyPlayedSubTitle: "Retoma la acción con tus últimos juegos",
  favoritesPageTitle: "❤️ {{alias}}, estos son tus favoritos",
  favoritesPageTitleGeneric: "❤️ Tus juegos favoritos",
  favoritesPageSubtitle: "Los juegos que más te gustan, todos en un solo lugar",
  favoritesGridTitle: "LOS FAVORITOS DE {{alias}}",
  favoritesGridTitleGeneric: "TUS FAVORITOS",
  favoritesEmptyMessage:
    "Aún no tienes juegos marcados como favoritos. Marca tus juegos favoritos dándole me gusta en el icono del corazón y cada vez que quieras jugar tus juegos preferidos vuelve aquí.",
  favoritesAdd: "Agregar a favoritos",
  favoritesRemove: "Quitar de favoritos",
  favoritesContinueTitle: "{{alias}}, continúa donde lo dejaste",
  favoritesContinueSubTitle: "Retoma la acción con tus últimos juegos",
  homeFavoritesCarouselTitle: "{{alias}}, juega tus favoritos",
  homeFavoritesCarouselTitleGeneric: "JUEGA TUS FAVORITOS",
  homeFavoritesCarouselSubTitle: "Tus preferidos, siempre a la mano",
  lotteryGamesTitle: "JUEGOS DE LOTERÍA",
  lotteryGamesSubTitle: "Prueba tu suerte con nuestras loterías",
  animalitosExpressTitle: "COMPRA TU ANIMALITO EXPRESS",
  animalitosExpressSubTitle: "Elige, compra y gana al instante",
  animalitosExpressBuy: "Comprar",
  animalitosExpressAll: "Todas",
  qbErrorAmount: "Ingresa un monto válido",
  qbErrorMinBet: "Mínimo {{min}} Bs",
  qbErrorMaxBet: "Máximo {{max}} Bs",
  qbErrorBalance: "Saldo insuficiente",
  qbErrorDrawClosed: "Sorteo cerrado",
  qbSuccessTitle: "¡Compra exitosa!",
  qbClose: "Cerrar",
  qbAriaLabel: "Compra rápida de animalito",
  qbNextDraw: "Sorteo",
  qbNoDraws: "Sin sorteos disponibles",
  qbDrawClosed: "Cerrado",
  qbAmountLabel: "Monto a apostar",
  qbConfirm: "Confirmar compra",
  providerBgamingTitle: "JUEGOS DE BGAMING",
  providerBgamingSubtitle: "Los mejores juegos de BGaming",
  providerEvoplayTitle: "JUEGOS DE EVO PLAY",
  providerEvoplaySubtitle: "Diversión sin límites con Evo Play",
  providerPragmaticTitle: "JUEGOS DE PRAGMATIC",
  providerPragmaticSubtitle: "Lo mejor de Pragmatic Play",
  allGamesTitle: "TODOS LOS JUEGOS",
  allGamesTitleProvider: "TODOS LOS JUEGOS DE {{provider}}",
  subcategoryAll: "Todos",
  subcategoryShowMore: "Ver más",
  subcategoryShowLess: "Ver menos",
  subcategoryFilterLabel: "Filtrar por subcategoría",
  dontMiss: "NO TE PIERDAS NINGUN TORNEO",
  dontMissTournaments: "No te pierdas ninguno de los torneos de Aprieta y Gana",
  tournamentRules: "Reglamento",
  promoFeatured: "Evento Destacado",
  promoPrizePool: "Pozo de Premios",
  promoTimeLeft: "Tiempo Restante",
  promoTimeLeftDays: "d",
  promoTimeLeftHours: "h",
  promoTimeLeftMinutes: "m",
  promoPlayers: "Jugadores",
  promoRecentPlayers: "Últimos jugadores participantes",
  promoViewProfile: "Perfil",
  promoViewStories: "Historias",
  promoAddContact: "Añadir",
  promoJoinNow: "Participar",
  promoLearnMore: "Saber más",
  promoViewGames: "Ver Juegos",
  promoLive: "EN VIVO",
  promoCasinoLive: "LO MEJOR DE CASINO EN VIVO",
  promoContests: "CONCURSOS EN VIVO",
  // Casino hero i18n keys
  casinoHeroTitle: "Casino ",
  casinoHeroAccent: "Live",
  casinoHeroSub: "Mesas en vivo con dealers reales. La experiencia del casino, desde tu silla.",
  casinoGamesCount: "Juegos",
  casinoProviders: "Proveedores",
  casinoLiveLabel: "En Vivo",
  casinoTrending: "En tendencia",
  casinoQuickPlay: "Juego rápido",
  casinoSearchResults: "Resultados",
  casinoAllGames: "Todos los juegos en vivo",
  casinoNoGames: "No se encontraron juegos",
  casinoAll: "Todos",
  viewAll: "Ver todo",
  loadMore: "Cargar más",
  previous: "Anterior",
  next: "Siguiente",
  casinoWinnersAria: "Últimos ganadores",
  casinoBadgeHot: "Hot",
  casinoBadgeNew: "Nuevo",
  casinoBadgePopular: "Popular",
  casinoCatRoulette: "Ruleta",
  casinoCatBlackJack: "Blackjack",
  casinoCatBaccarat: "Baccarat",
  casinoCatSicbo: "Sic Bo",
  casinoCatOneBJ: "One Blackjack",
  casinoCatDragonTiger: "Dragón Tigre",
  casinoCatContest: "Concursos",
  casinoCatABH: "ABH",
  casinoCatFootball: "Fútbol",
  casinoCatChroma: "Chroma",
  // Multi-Game Floating Button translations
  multiGameFloatingButton: "Juegos Rápidos",
  quickGamesTitle: "Juegos Rápidos",
  quickGamesDescription: "¡Sigue jugando mientras esperas tu juego principal!",
  hideQuickGames: "Ocultar",
  minimizeQuickGames: "Minimizar",
  playNow: "Jugar Ahora",
  noQuickGamesAvailable: "No hay juegos disponibles en este momento",
  unknownGame: "Juego Desconocido",
  unknownProvider: "Desconocido",
  loadingGames: "Cargando juegos...",
  gameLoading: "Cargando juego",
  gameErrorTitle: "No se pudo cargar el juego",
  gameErrorDescription: "Ocurrió un problema al intentar abrir el juego. Verifica tu conexión e intenta de nuevo.",
  gameRetry: "Reintentar",
  gameGoBack: "Volver",
  miniJuegosHeroTitle: "Mini Juegos",
  miniJuegosHeroAccent: "Rápidos",
  miniJuegosHeroSub: "Juegos rápidos, intensos y llenos de acción. Gana en segundos.",
  miniJuegosStatGames: "Juegos",
  miniJuegosStatCategories: "Categorías",
  miniJuegosCategories: "Categorías de Mini Juegos",
  miniJuegosLoading: "Cargando mini juegos...",
  miniJuegosEmpty: "No hay mini juegos disponibles",
  miniJuegosCatAll: "Todos",
  miniJuegosCat_crash: "JUEGOS DE CRASH",
  miniJuegosCatSub_crash: "Apuesta y retira antes del crash",
  miniJuegosCat_chicken: "CHICKEN GAMES",
  miniJuegosCatSub_chicken: "Aventuras con gallinas y premios",
  miniJuegosCat_mines: "BUSCAMINAS",
  miniJuegosCatSub_mines: "Esquiva las minas y gana",
  miniJuegosCat_plinko: "PLINKO",
  miniJuegosCatSub_plinko: "Deja caer y multiplica",
  miniJuegosCat_sports: "DEPORTE",
  miniJuegosCatSub_sports: "Juegos casuales y deportivos",
  miniJuegosCat_lottery: "LOTERÍAS",
  miniJuegosCatSub_lottery: "Raspa, gira y gana al instante",

  // Hero Banner Slide 2 translations
  casinoSlide2Title: "Vive la ",
  casinoSlide2Accent: "Experiencia",
  casinoSlide2Sub: "Ruleta, Blackjack, Baccarat y más con dealers profesionales en tiempo real.",
  slotsSlide2Title: "Tu diversión ",
  slotsSlide2Accent: "sin límites",
  slotsSlide2Sub: "Miles de tragamonedas, juegos de mesa y más esperándote.",
  miniJuegosSlide2Title: "Gana ",
  miniJuegosSlide2Accent: "al Instante",
  miniJuegosSlide2Sub: "Crash, Mines, Plinko y más juegos rápidos con premios instantáneos.",
  lotterySlide2Title: "Resultados ",
  lotterySlide2Accent: "en Tiempo Real",
  lotterySlide2Sub: "Sigue tus sorteos favoritos y cobra tus premios al instante.",
  horsesSlide2Title: "Apuesta en ",
  horsesSlide2Accent: "Vivo",
  horsesSlide2Sub: "Carreras nacionales e internacionales con streaming en directo.",
  gameSearchPlaceholder: "Buscar juegos...",
  gameSearchAriaLabel: "Buscar juegos",
  gameSearchClear: "Limpiar búsqueda",
  gameSearchFilters: "Filtros",
  gameSearchRemoveFilter: "Quitar filtro",
  gameSearchClearFilters: "Limpiar filtros",
  gameSearchProviders: "Proveedores",
  gameSearchCategories: "CATEGORÍAS",
  gameSearchResults: "resultados",
  categoryDice: "Dados",
  categoryFishing: "Pesca",
  categoryVirtualSports: "Deportes virtuales",
  categoryTableGames: "Juegos de mesa",
  categoryDomino: "Dominó",
  categoryPoker: "Poker",
};
